import { Grid } from "@mui/material";
import Header from "../../components/custom/Header";
import { Link } from "react-router-dom";
import SecondaryButton from "../../components/custom/SecondaryButton";
import { styled } from "@mui/system";
import { exportUsers, getAllUserData } from "../../services/userService";
import DataGrid2 from "../../components/custom/Table2/DataGrid2";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const columns = [
  // { key: "id", dataField: "id", caption: "id" },
  { key: "firstName", dataField: "firstName", caption: "Name" },
  { key: "lastName", dataField: "lastName", caption: "Surname" },
  {
    key: "accountType",
    dataField: "accountType",
    caption: "Type of Account",
    calculateCellValue: (rowData) => rowData?.role?.description,
  },
  {
    key: "dateCreated",
    dataField: "dateCreated",
    caption: "Account Created",
  },
  {
    key: "status",
    dataField: "Status",
    caption: "Status",
    calculateCellValue: (rowData) =>
      !rowData?.deleted ? "active" : "inactive",
  },
];

const toolbarOptions = {
  bulk: {
    show: false,
    request: null,
  },
  export: {
    show: true,
    request: exportUsers,
  },
};

const ListOfUsers = () => {
  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Grid item>
          <Header name="List of users" productShow={false} />
        </Grid>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <SecondaryButton
                component={Link}
                to="addUser"
                sx={{ mt: { xs: 2, md: 5 } }}
              >
                + Add new user
              </SecondaryButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {/* <Tabs
            sx={{ mt: { xs: 2, md: 5 } }}
            labels={[
              { text: "All" },
              { text: "Distributors" },
              { text: "Simple users" },
            ]}
          >
            <UsersAll />
            <Distributors />
            <SimpleUsers />
          </Tabs> */}
          <DataGrid2
            id={"usersAll"}
            filename="users"
            cols={columns}
            getAll={getAllUserData}
            toolbarOptions={toolbarOptions}
            editUrl={"/users/"}
          />
        </Grid>
      </StyledContainer>
    </>
  );
};

export default ListOfUsers;
